import React, { FC } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';

import { LoaderComponents } from 'components';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
    },
  });

const Loader: FC<WithStyles<typeof styles>> = ({ classes }) => {
  const { Block, Divider, Image } = LoaderComponents;

  return (
    <Paper className={classes.root}>
      <Grid container direction="column" wrap="nowrap" spacing={2}>
        <Grid container item spacing={2} alignItems="center">
          <Grid item>
            <Image width={50} height={50} shape="circle" />
          </Grid>
          <Grid item xs>
            <Block width="70%" />
          </Grid>
        </Grid>
        <Grid container item>
          <Grid item xs>
            <Image width="100%" height={300} />
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" spacing={2} wrap="nowrap">
            <Grid item xs>
              <Block width="90%" />
            </Grid>
            <Grid item xs>
              <Block width="60%" />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container alignItems="center">
            <Grid item xs>
              <Block width="40%" />
            </Grid>
            <Grid item>
              <Image shape="circle" width={50} height={50} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container direction="column" wrap="nowrap" spacing={1}>
            <Grid item>
              <Divider />
            </Grid>
            <Grid item>
              <Grid container alignItems="center" spacing={1}>
                <Grid item>
                  <Image shape="circle" width={30} height={30} />
                </Grid>
                <Grid item xs>
                  <Block width="100%" />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withStyles(styles)(Loader);
